import { FactoryDigitalmallBackofficeV1Service } from '../../app/genericApiGenerated';

const buildService = (
  data: any,
  selectedService?: FactoryDigitalmallBackofficeV1Service
): FactoryDigitalmallBackofficeV1Service => {
  const service: FactoryDigitalmallBackofficeV1Service = {};

  // This one for handling concurrent updates
  if (
    selectedService !== undefined &&
    selectedService['meta'] !== undefined &&
    selectedService['meta']['update_time'] !== undefined
  ) {
    service.meta = {
      ...service.meta,
      update_time: selectedService['meta']['update_time']
    };
  }

  if (data['name'] !== undefined) {
    service.name = data['name'];
  }

  if (data['display_name'] !== undefined) {
    service.display_name = data['display_name'];
  }

  if (data['category'] !== undefined) {
    service.category = data['category'];
  }

  if (data['description'] !== undefined) {
    service.description = data['description'];
  }

  if (data['logo'] !== undefined) {
    service.logo = data['logo'];
  }

  if (data['service_uri'] !== undefined) {
    service.service_uri = data['service_uri'];
  }

  if (data['price'] !== undefined) {
    service.price = data['price'];
  }

  if (data['location_address'] !== undefined) {
    service.location_address = data['location_address'];
  }

  if (data['mall'] !== undefined) {
    service.mall = data['mall'];
  }

  if (data['meta'] !== undefined && data['meta']['create_time'] !== undefined) {
    service.meta = {
      ...service.meta,
      create_time: data['meta']['create_time']
    };
  }

  if (
    data['meta'] !== undefined &&
    data['meta']['creation_user'] !== undefined
  ) {
    service.meta = {
      ...service.meta,
      creation_user: data['meta']['creation_user']
    };
  }

  if (data['meta'] !== undefined && data['meta']['update_time'] !== undefined) {
    service.meta = {
      ...service.meta,
      update_time: data['meta']['update_time']
    };
  }

  if (data['meta'] !== undefined && data['meta']['update_user'] !== undefined) {
    service.meta = {
      ...service.meta,
      update_user: data['meta']['update_user']
    };
  }

  if (data['meta'] !== undefined && data['meta']['delete_time'] !== undefined) {
    service.meta = {
      ...service.meta,
      delete_time: data['meta']['delete_time']
    };
  }

  if (
    data['meta'] !== undefined &&
    data['meta']['deletion_user'] !== undefined
  ) {
    service.meta = {
      ...service.meta,
      deletion_user: data['meta']['deletion_user']
    };
  }

  if (data['meta'] !== undefined && data['meta']['sfmc_mid'] !== undefined) {
    service.meta = {
      ...service.meta,
      sfmc_mid: data['meta']['sfmc_mid']
    };
  }

  if (
    data['meta'] !== undefined &&
    data['meta']['resource_name'] !== undefined
  ) {
    service.meta = {
      ...service.meta,
      resource_name: data['meta']['resource_name']
    };
  }

  if (
    data['meta'] !== undefined &&
    data['meta']['operation_name'] !== undefined
  ) {
    service.meta = {
      ...service.meta,
      operation_name: data['meta']['operation_name']
    };
  }

  return service;
};
export default buildService;
